export function BuyPassButtonNavbar({ setTab }) {
  return (
    <li>
      <a
        className="button"
        href="/donate"
      >
        Купить проходку
      </a>
    </li>
  );
}
